function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg213StBarts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACABB1"
    },
    d: "M428.364,213.069h-72.19c0-13.172-10.679-23.851-23.851-23.851l-19.081,38.162   c0,0,20.353,57.243,19.718,57.243h23.85c13.173,0,23.851-10.677,23.851-23.851c13.173,0,23.851-10.679,23.851-23.851h-0.795   C416.889,236.919,428.364,226.242,428.364,213.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACABB1"
    },
    d: "M83.637,213.069h72.189c0-13.172,10.679-23.851,23.851-23.851l19.081,38.162   c0,0-20.353,57.243-19.718,57.243h-23.85c-13.173,0-23.851-10.677-23.851-23.851c-13.173,0-23.851-10.679-23.851-23.851h0.795   C95.111,236.919,83.637,226.242,83.637,213.069z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "332.324,341.863 332.324,351.403 179.676,351.403 179.676,341.863 141.516,341.863   141.516,380.025 179.676,380.025 179.676,389.565 332.324,389.565 332.324,380.025 370.484,380.025 370.484,341.863 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M179.676,189.217v95.403c0,58.423,76.324,76.324,76.324,76.324s76.324-17.901,76.324-76.324v-95.403  L256,179.676L179.676,189.217z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.679,
    y: 227.384,
    style: {
      fill: "#D80027"
    },
    width: 152.643,
    height: 57.244
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "294.162,141.516 294.162,155.826 284.621,160.597 275.081,151.056 275.081,122.435   236.919,122.435 236.919,151.056 227.379,160.597 217.838,155.826 217.838,141.516 179.676,141.516 179.676,189.217   332.324,189.217 332.324,141.516 "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg213StBarts);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIi8+CjxnPgoJPHBhdGggc3R5bGU9ImZpbGw6I0FDQUJCMTsiIGQ9Ik00MjguMzY0LDIxMy4wNjloLTcyLjE5YzAtMTMuMTcyLTEwLjY3OS0yMy44NTEtMjMuODUxLTIzLjg1MWwtMTkuMDgxLDM4LjE2MiAgIGMwLDAsMjAuMzUzLDU3LjI0MywxOS43MTgsNTcuMjQzaDIzLjg1YzEzLjE3MywwLDIzLjg1MS0xMC42NzcsMjMuODUxLTIzLjg1MWMxMy4xNzMsMCwyMy44NTEtMTAuNjc5LDIzLjg1MS0yMy44NTFoLTAuNzk1ICAgQzQxNi44ODksMjM2LjkxOSw0MjguMzY0LDIyNi4yNDIsNDI4LjM2NCwyMTMuMDY5eiIvPgoJPHBhdGggc3R5bGU9ImZpbGw6I0FDQUJCMTsiIGQ9Ik04My42MzcsMjEzLjA2OWg3Mi4xODljMC0xMy4xNzIsMTAuNjc5LTIzLjg1MSwyMy44NTEtMjMuODUxbDE5LjA4MSwzOC4xNjIgICBjMCwwLTIwLjM1Myw1Ny4yNDMtMTkuNzE4LDU3LjI0M2gtMjMuODVjLTEzLjE3MywwLTIzLjg1MS0xMC42NzctMjMuODUxLTIzLjg1MWMtMTMuMTczLDAtMjMuODUxLTEwLjY3OS0yMy44NTEtMjMuODUxaDAuNzk1ICAgQzk1LjExMSwyMzYuOTE5LDgzLjYzNywyMjYuMjQyLDgzLjYzNywyMTMuMDY5eiIvPgo8L2c+Cjxwb2x5Z29uIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiBwb2ludHM9IjMzMi4zMjQsMzQxLjg2MyAzMzIuMzI0LDM1MS40MDMgMTc5LjY3NiwzNTEuNDAzIDE3OS42NzYsMzQxLjg2MyAxNDEuNTE2LDM0MS44NjMgICAxNDEuNTE2LDM4MC4wMjUgMTc5LjY3NiwzODAuMDI1IDE3OS42NzYsMzg5LjU2NSAzMzIuMzI0LDM4OS41NjUgMzMyLjMyNCwzODAuMDI1IDM3MC40ODQsMzgwLjAyNSAzNzAuNDg0LDM0MS44NjMgIi8+CjxwYXRoIHN0eWxlPSJmaWxsOiMwMDUyQjQ7IiBkPSJNMTc5LjY3NiwxODkuMjE3djk1LjQwM2MwLDU4LjQyMyw3Ni4zMjQsNzYuMzI0LDc2LjMyNCw3Ni4zMjRzNzYuMzI0LTE3LjkwMSw3Ni4zMjQtNzYuMzI0di05NS40MDMgIEwyNTYsMTc5LjY3NkwxNzkuNjc2LDE4OS4yMTd6Ii8+CjxyZWN0IHg9IjE3OS42NzkiIHk9IjIyNy4zODQiIHN0eWxlPSJmaWxsOiNEODAwMjc7IiB3aWR0aD0iMTUyLjY0MyIgaGVpZ2h0PSI1Ny4yNDQiLz4KPHBvbHlnb24gc3R5bGU9ImZpbGw6I0ZGREE0NDsiIHBvaW50cz0iMjk0LjE2MiwxNDEuNTE2IDI5NC4xNjIsMTU1LjgyNiAyODQuNjIxLDE2MC41OTcgMjc1LjA4MSwxNTEuMDU2IDI3NS4wODEsMTIyLjQzNSAgIDIzNi45MTksMTIyLjQzNSAyMzYuOTE5LDE1MS4wNTYgMjI3LjM3OSwxNjAuNTk3IDIxNy44MzgsMTU1LjgyNiAyMTcuODM4LDE0MS41MTYgMTc5LjY3NiwxNDEuNTE2IDE3OS42NzYsMTg5LjIxNyAgIDMzMi4zMjQsMTg5LjIxNyAzMzIuMzI0LDE0MS41MTYgIi8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };